const signInEvents = {
  action: "sign-in",
  labels: {
    navigation: "navigation",
    myDesigns: "my-designs",
    noDesignsPlaceholder: "no-designs-placeholder",
    createRoom: "create-room",
    roomPage: "room-page",
    loginSplash: "login-splash",
    loginBanner: "login-banner:login",
  },
};

export default signInEvents;
